import React from 'react';
import {
  Inbox, List, Building2, Mail, Sparkles, SlidersHorizontal, Shield,
} from 'lucide-react';

const NAV_ITEMS = [
  { key: 'dashboard', icon: Inbox, label: 'Today', badgeKey: 'today', badgeTone: 'alert' },
  { key: 'intelligence', icon: List, label: 'All stories' },
  { key: 'companies', icon: Building2, label: 'Companies', badgeKey: 'companies', badgeTone: 'muted', alsoActiveOn: ['watchlist'] },
  { key: 'briefs', icon: Mail, label: 'Briefs' },
  { key: 'ai', icon: Sparkles, label: 'AI Assistant' },
  { key: 'settings', icon: SlidersHorizontal, label: 'Settings' },
];

function NavButton({ active, onClick, icon: Icon, label, badge, badgeTone }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={active ? 'page' : undefined}
      className={`group relative w-full flex items-center gap-3 h-9 pl-3 pr-2.5 rounded-md text-left text-sm transition ${
        active
          ? 'bg-white/[0.08] text-white font-medium'
          : 'text-[#aab4c5] hover:bg-white/[0.05] hover:text-white'
      }`}
    >
      {active && <span className="absolute left-0 top-2 bottom-2 w-0.5 rounded-full bg-[#6b97ff]" />}
      <Icon size={17} strokeWidth={active ? 2.1 : 1.8} className={`flex-shrink-0 ${active ? 'text-[#6b97ff]' : ''}`} />
      <span className="flex-1 truncate">{label}</span>
      {badge > 0 && (
        badgeTone === 'alert' ? (
          <span className="min-w-[20px] h-5 px-1.5 flex items-center justify-center rounded-full bg-[#ff7a70] text-[#1a0d0c] text-[11px] font-semibold">
            {badge > 99 ? '99+' : badge}
          </span>
        ) : (
          <span className="text-xs font-medium text-[#6e7a92] group-hover:text-[#aab4c5]">
            {badge > 99 ? '99+' : badge}
          </span>
        )
      )}
    </button>
  );
}

function Sidebar({
  view,
  setView,
  intelligenceCount,
  companyCount,
  alertCount = 0,
}) {
  const badges = {
    today: alertCount || intelligenceCount,
    companies: companyCount,
  };

  const renderItem = item => (
    <NavButton
      key={item.key}
      active={view === item.key || Boolean(item.alsoActiveOn?.includes(view))}
      onClick={() => setView(item.key)}
      icon={item.icon}
      label={item.label}
      badge={item.badgeKey ? badges[item.badgeKey] : 0}
      badgeTone={item.badgeTone}
    />
  );

  return (
    <aside className="w-[240px] flex-shrink-0 h-screen sticky top-0 overflow-y-auto hidden md:flex flex-col bg-[#0f141b] border-r border-white/[0.06]">
      <div className="h-[54px] flex-shrink-0 px-5 flex items-center gap-2.5 border-b border-white/[0.06]">
        <Shield size={20} strokeWidth={2} className="text-[#6b97ff] flex-shrink-0" aria-hidden="true" />
        <span className="text-[15px] font-semibold text-white tracking-tight">CorpSentinel</span>
      </div>

      <nav className="px-3 pt-4 space-y-0.5" aria-label="Main">
        {NAV_ITEMS.map(renderItem)}
      </nav>
    </aside>
  );
}

export default Sidebar;
